import { NxAccordionModule } from "@allianz/ng-aquila/accordion";
import { NxBadgeModule } from "@allianz/ng-aquila/badge";
import { NxButtonModule } from "@allianz/ng-aquila/button";
import { NxCardModule } from "@allianz/ng-aquila/card";
import { NxCopytextModule } from "@allianz/ng-aquila/copytext";
import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxIconModule } from "@allianz/ng-aquila/icon";
import { NxDialogService, NxModalRef } from "@allianz/ng-aquila/modal";
import { NxModalModule } from "@allianz/ng-aquila/modal";
import { NxMultiStepperComponent } from "@allianz/ng-aquila/progress-stepper";
import { NxProgressbarModule } from "@allianz/ng-aquila/progressbar";
import { NxTableModule } from "@allianz/ng-aquila/table";
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Store } from "@ngxs/store";
import {
  CAMPAGIN_GCR_CATEGORY,
  CAMPAGIN_GWP_CATEGORY,
  CAMPAGIN_POLICY_COUNT_CATEGORY,
  CONSTANTS,
} from "@shared/enums/index.enum";
import { CustomStepperComponent } from "@shared/modules/custom-stepper/custom-stepper.component";
import { NumberToReadablePipe } from "@shared/pipes/number-to-readable.pipe";
import { LayoutBreakPointsService } from "@shared/services/layout-break-points.service";
import moment from "moment";

@Component({
  selector: "app-club-campaign-card",
  templateUrl: "./club-campaign-card.component.html",
  styleUrls: ["./club-campaign-card.component.scss"],
  standalone: true,
  imports: [
    CustomStepperComponent,
    NxAccordionModule,
    NxBadgeModule,
    NxButtonModule,
    NxCardModule,
    NxCopytextModule,
    NxGridModule,
    NxHeadlineModule,
    NxIconModule,
    NxModalModule,
    NxProgressbarModule,
    NxTableModule,
  ],
})
export class ClubCampaignCardComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild("template") public templateRef!: TemplateRef<any>;
  @ViewChild("stepper1", { read: NxMultiStepperComponent })
  public stepper!: NxMultiStepperComponent;
  @ViewChild("stepper2", { read: NxMultiStepperComponent })
  public stepper2!: NxMultiStepperComponent;

  @Input() public clubData;
  @Input() public index;

  private readonly numberToReadablePipe: NumberToReadablePipe;

  private readonly currentIndex = 1;
  private readonly totalProgressPercentage = 100;
  protected tempCampaignRankData = [];

  private readonly CAMPAIGN_CLUB_MSG =
    "Congratulation on achieving the title of ";
  private readonly CAMPAIGN_GROWTH_MSG = "Congratulation on achieving the ";
  private desktopView: boolean = false;
  private readonly currentOngoingRankIndex: any;

  private readonly templateDialogRef?: NxModalRef<any>;

  private readonly defaultStepIndex = 3;

  constructor(
    private readonly dialogService: NxDialogService,
    private readonly store: Store,
    private readonly layoutBreakpointService: LayoutBreakPointsService,
  ) {
    this.numberToReadablePipe = new NumberToReadablePipe();
  }

  ngOnInit(): void {
    // const data = this.store.selectSnapshot((state) => state.CampaignState.currentClubCampaignList)
    this.tempCampaignRankData = this.clubData.ranks;
    this.layoutBreakpointService
      .subscribeLayoutChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.desktopView = this.layoutBreakpointService.renderDesktop();
      });
  }

  protected test(value: any): void {
    // Navigate to the next step
    if (this.stepper) {
      value.complete = true;
      this.stepper.next();
    }
  }

  protected test2(value: any): void {
    // Navigate to the next step
    if (this.stepper2) {
      value.complete = true;
      this.stepper2.next();
    }
  }

  protected openFromTemplate(): void {
    this.dialogService.open(this.templateRef, {
      showCloseIcon: false,
      ariaLabel: "A modal with fixed width",
      panelClass: "club-campaign-modal",
    });
  }

  protected closeTemplateDialog(): void {
    this.templateDialogRef?.close();
  }

  // My Logic starts here
  protected getImageType(name): string {
    const nameParts = name.split(".");
    const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
    return this.getMimeType(fileExtension);
  }

  protected getMimeType(fileType): string {
    switch (fileType) {
      case "jpg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "svg":
        return "image/svg+xml";
      default:
        return "image/png"; // Default to PNG
    }
  }

  protected calculateRankPercentage(completed): string | number {
    if (completed) {
      const percentage = completed / this.totalProgressPercentage;
      return percentage.toFixed(2);
    }
    return 0;
  }

  protected getCriteriaCategoryDescp(code): string {
    const campaignReqCategoryLOV = this.store.selectSnapshot(
      (res) => res.CampaignState.campaignReqCategory,
    );
    if (code) {
      return campaignReqCategoryLOV.find((item) => item.code === code)?.descp;
    }
    return "";
  }

  protected isGCRCatgeory(catCode): boolean {
    const checkValue = CAMPAGIN_GCR_CATEGORY.find(
      (res) => res.code === catCode,
    );
    return checkValue ? true : false;
  }

  protected isGWPCatgeory(catCode): boolean {
    const checkValue = CAMPAGIN_GWP_CATEGORY.find(
      (res) => res.code === catCode,
    );
    return checkValue ? true : false;
  }

  protected isPolicyCountCatgeory(catCode): boolean {
    const checkValue = CAMPAGIN_POLICY_COUNT_CATEGORY.find(
      (res) => res.code === catCode,
    );
    return checkValue ? true : false;
  }

  protected getCriteriaValueDescp(code): string {
    const campaignValConditionLOV = this.store.selectSnapshot(
      (res) => res.CampaignState.campaignValCondition,
    );
    if (code) {
      return campaignValConditionLOV.find((item) => item.code === code)?.descp;
    }
    return "";
  }

  protected stepRankStatus(value): boolean {
    return value === "INCOMPLETE" ? true : false;
  }

  protected formatDate(date: Date, format: string): string {
    return moment(date, CONSTANTS.YYYY_MM_DD).format(format);
  }

  protected getCongratulatoryMessage(data) {
    if (!data.currentRank) {
      return;
    }

    if (data.growthInd) {
      return this.CAMPAIGN_GROWTH_MSG + `${data.currentRank.name}`;
    }
    return this.CAMPAIGN_CLUB_MSG + `${data.currentRank.name}`;
  }

  protected getImageInfo(data): string {
    if (data.status !== "INCOMPLETE") {
      return (
        "data:" +
        this.getImageType(data.badgeFilename) +
        ";base64," +
        data.badgeBase64
      );
    }

    return "assets/images/shared/campaign/disabled.svg";
  }

  protected getCriteriaTarget(data): string {
    return data.isAchieved ? "Achieved" : "additional";
  }

  protected getCriteriaValueBasedOnCategory(criteria): string {
    if (this.isGWPCatgeory(criteria.category)) {
      const amount = this.numberToReadablePipe.transform(
        criteria.remainingProductionValue,
      );
      return `RM ${amount}`;
    } else {
      const format = criteria.remainingProductionValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return format;
    }
  }

  protected getGCRValueBasedOnCondition(criteria): string {
    if (criteria.valueCondition === "BETWEEN") {
      return `${criteria.fromValue}% to ${criteria.toValue}%`;
    } else {
      return `${criteria.value}%`;
    }
  }
}
